export const getLocationHash = () => location.hash.replace(/^#/, '');

export const updateHash = hash => (location.hash = hash);

export const clearHash = (resetSlug = ' ') => history.replaceState(null, null, resetSlug);

export const getLocationQuery = () => location.search;

export const isOnHomepage = () => location.pathname.length <= 1;

export const isOnMarketPage = () => location.href.includes('/market');

export const getLocationSlug = () =>
  location.pathname
    .replace(/\/*$/, '')
    .split('/')
    .pop();

export const getLocationPathname = () => location.pathname;

export const isRouteActive = (route, { pathname }) => route === pathname;
